import React, {useEffect, useState} from "react";
import {Form} from "antd";
import General from "../item/General";
import Other from "../item/Other";
import Seniority from "../item/Seniority";
import dayjs from "dayjs";
import {Option} from "antd/lib/mentions";
import {useTranslation} from "react-i18next";
import DG_Submit from "../../../../../../common/button/Submit";
import DG_Cancel from "../../../../../../common/button/Cancel";
import DG_Button from "../../../../../../common/button/Button";
import DG_Form from "../../../../../../custom/data-entry/form";
import {loadJobPositionsApi, loadReasonLeaveApi} from "../../../../../../api/common/job/position/api";
import {loadContractsApi} from "../../../../../../api/common/contract/api";
import {dayStartContractType} from "../item/mapData/dayStartContractType";
import {
    addOnLeaveConfigApi,
    loadDetailOnLeaveConfigApi,
    updateOnLeaveConfigApi
} from "../../../../../../api/setting/timekeeping/annual-leave";

const FormContent = (props) => {
    const [form] = Form.useForm();
    const {t} = useTranslation()
    const [dataPosition, setDataPosition] = useState([])
    const [dataContractType, setDataContractType] = useState([])
    const [dataContractTypeAdvance, setDataContractTypeAdvance] = useState([])
    const [dataDayStartCounted, setDataDayStartCounted] = useState([])
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [isSetting, setIsSetting] = useState(false)
    const [namUpdate, setName] = useState('')
    const [loading, setLoading] = useState(false)
    const [dataReasonLeave, setDataReasonLeave] = useState([])

    useEffect(() => {
        loadJobPositionsApi().then((response) => {
            setDataPosition(response.items)
        });

        loadContractsApi().then((response) => {
            setDataContractType(response.items)
            setDataContractTypeAdvance(response.items);
            setDataDayStartCounted(response.items);
        });

        loadReasonLeaveApi().then((response) => {
            setDataReasonLeave(response.items)
        });

    }, []);

    function onChangeDatePickerStart(_date, dateString) {
        setStartDate(dateString)
    }

    function onChangeDatePickerEnd(_date, dateString) {
        setEndDate(dateString)
    }

    const startMonth = startDate.split("/")[0]
    const startYear = startDate.split("/")[1]
    const endMonth = endDate.split("/")[0]
    const endYear = endDate.split("/")[1]

    const onFinish = (values) => {
        values = {
            ...values,
            name: values.name,
            startMonth: Number(startMonth),
            startYear: Number(startYear),
            endMonth: Number(endMonth),
            endYear: Number(endYear),
            departmentIds: values?.departmentIds,
            positionIds: values?.positionIds,
            contractTypeIds: values?.contractTypeIds,
            contractAdvanceIds: values?.contractAdvanceIds,
            dayNewLeave: values.dayNewLeave || "enough",
            dayWorkOnLeave: values.dayWorkOnLeave || 20,
            reasonCodes: values?.reasonCodes?.toString(),
        }
        setLoading(true)
        if (props.id) {
            updateOnLeaveConfigApi(props.id, values).then(r => r)
                .finally(()=> setLoading(false));
        } else {
            addOnLeaveConfigApi(values).then(r => r)
                .finally(()=> setLoading(false));
        }
    };

    const onFinishFailed = (errorInfo) => {
        props.scrollToFirstError(errorInfo.errorFields);
    };

    function setValueUpdate(response) {
        let data = response;

        let departmentArr = []
        data?.onLeaveConfigDepartments?.forEach((item) => {
            departmentArr.push(item.departmentId)
        })

        let positionArr = []
        data?.onLeaveConfigPositions?.forEach((item) => {
            positionArr.push(item.positionId)
        })

        let contractTypeOnLeaveArr = []
        data?.contractTypeOnLeaves?.forEach((item) => {
            contractTypeOnLeaveArr.push(item.contractTypeId)
        })

        let contractTypeAdvanceArr = []
        data?.contractTypeAdvances?.forEach((item) => {
            contractTypeAdvanceArr.push(item.contractTypeId)
        })

        let reasonCodeArr = []
        if (data?.reasonCodes){
            const reasonCodeArrs = data.reasonCodes.replace("[", "").replace("]", "").split(",")
            reasonCodeArrs.forEach((item) => {
                reasonCodeArr.push(item.trim())
            })
        }

        form.setFieldsValue(
            {
                ...data,
                startMonth: dayjs(`${data?.startMonth} ${data?.startYear}`, "M/YYYY"),
                endMonth: data?.endMonth !== 0 && data?.endYear !== 0 ? dayjs(`${data?.endMonth} ${data?.endYear}`, "M/YYYY") : null,
                departmentIds: departmentArr,
                positionIds: positionArr,
                contractTypeOnLeaveIds: contractTypeOnLeaveArr,
                contractTypeAdvanceIds: contractTypeAdvanceArr,
                settingMaternity: data.settingMaternity,
                allowedAdvanceLeave: data.allowedAdvanceLeave,
                allowedSeniority: data.allowedSeniority,
                reasonCodes: reasonCodeArr
            }
        );
    }

    const [isAllowed, setIsAllowed] = useState(false);

    const [dayNewLeave, setDayNewLeave] = useState("")
    const [cumulative, setCumulative] = useState("")
    const [advanceLeave, setAdvanceLeave] = useState("")
    const [allowedSeniority, setAllowedSeniority] = useState(true)

    useEffect(() => {
        if (props.id) {
            loadDetailOnLeaveConfigApi(props.id).then((response) => {
                setName(response?.name)
                setValueUpdate(response)
                setDayNewLeave(response.dayNewLeave)
                setCumulative(response.cumulativeEndTime)
                setAdvanceLeave(response.maximumAdvanceLeave)
                setStartDate(`${response.startMonth}/${response.startYear}`)
                if (response.endMonth !== 0 && response.endYear !== 0)
                    setEndDate(`${response.endMonth}/${response.endYear}`)
                setIsAllowed(response.allowedAdvanceLeave)
                setIsSetting(response?.settingMaternity)
                setAllowedSeniority(response.allowedSeniority)
            });
        } else {
            form.resetFields();
        }
    }, [props.id]);

    function getPosition() {
        return dataPosition?.map((item, key) => {
            return (
                <Option key={key} value={item.id} dataSearch={item.name}>
                    {item.name}
                </Option>
            )
        })
    }

    function getContractType() {
        return dataContractType?.map((item, key) => {
            return (
                <Option key={key} value={item.contractTypeId} dataSearch={item.name}>
                    {item.name}
                </Option>
            )
        })
    }

    function getContractTypeAdvance() {
        return dataContractTypeAdvance?.map((item, key) => {
            return (
                <Option key={key} value={item.contractTypeId} dataSearch={item.name}>
                    {item.name}
                </Option>
            )
        })
    }

    function addPrefixDayStartCounted() {
        let dataDayStartCountedArr = []
        dataDayStartCounted?.forEach((item) => {
            dataDayStartCountedArr.push({
                contractTypeId: item.contractTypeId,
                name: `${t("dayStartContractType.dayOf")} ${item.name}`
            })
        })

        return dataDayStartCountedArr;
    }

    function getDayStartCounted() {
        // let dataDayStartCountedMap = [...dayStartContractType, ...addPrefixDayStartCounted()]
        let dataDayStartCountedMap = [...dayStartContractType]
        return dataDayStartCountedMap?.map((item, key) => {
            return (
                <Option key={key} value={item.contractTypeId}>
                    {item.name}
                </Option>
            )
        })
    }

    function getReasonLeave() {
        return dataReasonLeave?.map((item, key) => {
            return (
                <Option key={key} value={item.code} dataSearch={item.reason}>
                    {item.reason}
                </Option>
            )
        })
    }

    const dataSelectPosition = getPosition();
    const dataSelectContractType = getContractType();
    const dataSelectContractTypeAdvance = getContractTypeAdvance();
    const mapDayStartContractType = getDayStartCounted();
    const dataSelectReasonLeave = getReasonLeave();

    return (
        <DG_Form
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            mode={!!props.id ? "update" : "add"}
            layout={"horizontal"}
            className={'h-full'}
        >
            <DG_Button
                title={props.id ? t("tnp.components.timekeeping.text70") + namUpdate : t("tnp.components.timekeeping.text69")}>
                <DG_Cancel/>
                <DG_Submit loading={loading}/>
            </DG_Button>
            <div style={{height: "100%", overflow: "auto"}} className={'px-6 pt-4 pb-16'}>
                <General
                    id={props.idGeneral}
                    dayNewLeaveProps={dayNewLeave}
                    cumulativeEndtimeProps={cumulative}
                    getPosition={getPosition}
                    getContractType={getContractType}
                    dataSelectPosition={dataSelectPosition}
                    dataSelectContractType={dataSelectContractType}
                    onChangeDatePickerStart={onChangeDatePickerStart}
                    onChangeDatePickerEnd={onChangeDatePickerEnd}
                    mapDayStartContractType={mapDayStartContractType}
                    dataSelectReasonLeave={dataSelectReasonLeave}
                />
                <Seniority
                    id={props.idSeniority}
                    allowedSeniority={allowedSeniority}
                />
                <Other
                    id={props.idOther}
                    isAllowed={isAllowed}
                    setIsAllowed={setIsAllowed}
                    dataSelectContractTypeAdvance={dataSelectContractTypeAdvance}
                    maximumAdvanceLeaveProps={advanceLeave}
                    isSetting={isSetting}
                />
            </div>
        </DG_Form>
    );
};

export default FormContent;
